export const talentDictionary = [
  {
    name: '行动',
    description: '喜欢马上将想法付诸行动，想到就做，而不仅仅只是谈论。',
    keywords: ['没有耐心', '有影响力', '发起', '催化', '推进', '快速', '活跃'],
  },
  {
    name: '完美',
    description: '专注于优势，追求卓越，精益求精，在自己的领域有鉴赏力而挑剔。',
    keywords: [
      '有选择的',
      '优势导向',
      '注重质量',
      '结果导向',
      '卓越意识',
      '有鉴赏力',
      '挑剔',
      '评判',
      '不容易满意',
    ],
  },
  {
    name: '统率',
    description: '有大将风度，运筹帷幄，指挥若定。',
    keywords: [
      '坚决',
      '澄清',
      '奋发',
      '有说服力',
      '喜欢挑战',
      '令人生畏',
      '坚定',
      '控制',
      '固执己见',
      '令人印象深刻',
      '意志坚强',
      '直言不讳',
    ],
  },
  {
    name: '自信',
    description: '对冒险和应对生活的能力充满信心，内心有自己的处世准则，做决定时成竹在胸。',
    keywords: [
      '独立自主',
      '笃定',
      '自知之明',
      '自给自足',
      '富有直觉',
      '紧锣密鼓',
      '控制',
      '稳重',
      '不屈不挠',
    ],
  },
  {
    name: '沟通',
    description: '善于用言辞表达想法，善于与人交谈，擅长讲解事物。',
    keywords: ['健谈', '演说', '透明', '合作', '善表达', '迷人', '有趣'],
  },
  {
    name: '追求',
    description: '希望产生巨大的影响力，行事独立，渴望得到认可、重视、赏识。',
    keywords: [
      '受人钦佩',
      '可靠',
      '成功',
      '被看见的',
      '有影响力',
      '独立自主',
      '受众导向',
      '专业',
      '卓越',
    ],
  },
  {
    name: '竞争',
    description: '参照他人的表现来衡量自身的进步，力争第一，陶醉于胜出的喜悦中。',
    keywords: ['保持记录', '比较', '胜出', '衡量', '鼓舞', '奋发', '紧锣密鼓', '有选择的'],
  },
  {
    name: '取悦',
    description: '喜欢结交新朋友并博取他们的欢心，能够在人际交往中打破沉默，享受与他人建交。',
    keywords: ['迷人', '合作', '热爱交际', '有影响力', '合群', '有趣', '发起', '讨人喜欢'],
  },
  {
    name: '成就',
    description: '兢兢业业，锲而不舍，乐于忙忙碌碌，不断有所产出。',
    keywords: ['奋发', '孜孜不倦', '紧锣密鼓', '自我驱动', '多产', '有抱负', '独立自主'],
  },
  {
    name: '纪律',
    description: '喜欢可预测、井井有条的生活方式，喜欢建立规程，遵章守纪。',
    keywords: [
      '可预见',
      '注重细节',
      '有条理',
      '有效',
      '一丝不苟',
      '结构化',
      '整洁有序',
      '及时',
      '有准备',
      '有计划',
      '精确',
    ],
  },
  {
    name: '统筹',
    description: '具备组织能力，灵活又有序，善于合理安排资源以实现最大功效。',
    keywords: ['灵活', '合作', '控制', '协同', '多角度思考', '善安排', '快速及时', '有办法'],
  },
  {
    name: '专注',
    description: '能够确定方向，贯彻始终，必要时也能作出调整，喜欢先确定重点，再着手行动。',
    keywords: ['目标导向', '不屈不挠', '奋发', '有效', '一心一意', '进度意识', '有选择的', '反感被打扰'],
  },
  {
    name: '信仰',
    description: '拥有某种不变的核心价值观，并由此形成明确的生活目标。',
    keywords: ['笃定', '稳重', '恒久不变', '有原则', '热诚', '忠诚', '自我牺牲'],
  },
  {
    name: '责任',
    description: '言而有信，尽职尽责，事必躬亲。',
    keywords: [
      '勤勉',
      '兢兢业业',
      '评判',
      '忠诚',
      '奋发',
      '尽责',
      '可靠',
      '严肃',
      '言出必行',
      '自我牺牲',
      '积极响应',
      '独立自主',
    ],
  },
  {
    name: '公平',
    description: '深知应平等待人，希望有固定的章程以及清晰的规则和程序，每个人都可以遵循。',
    keywords: ['公正', '平等', '均衡', '服从规则', '可预见', '始终如一', '正直', '实际', '效率高'],
  },
  {
    name: '排难',
    description: '善于发现问题并解决问题，遇到困难干劲倍增。',
    keywords: ['问题导向', '奋发', '追根究底', '关注劣势', '积极响应', '无畏', '有洞察力'],
  },
  {
    name: '审慎',
    description: '机警缜密，做决定或选择时慎之又慎，识别危险，小心翼翼落脚。',
    keywords: [
      '细心',
      '有所保留',
      '保守',
      '明智',
      '深思熟虑',
      '严肃',
      '内敛',
      '善于观察',
      '警觉',
      '风险厌恶',
      '服从规则',
    ],
  },
  {
    name: '适应',
    description: '活在当前，接受现实，随遇而安，非常灵活。',
    keywords: ['灵活', '积极响应', '随和', '活在当下', '随性', '和气'],
  },
  {
    name: '包容',
    description: '善于接纳他人，关心被忽略的人，并努力让这些人融入集体。',
    keywords: ['接纳', '宽容', '交流', '理解', '利他', '热情友好', '敏感', '使成为一体'],
  },
  {
    name: '关联',
    description: '深信世间万物都彼此关联，相信世间没有巧合，凡事必有成因。',
    keywords: ['使成为一体', '探究', '精神上的', '抚慰', '思维敏捷', '神秘', '哲思', '咨询', '倾听'],
  },
  {
    name: '个别',
    description: '对每个人的独有特质兴趣盎然，知道如何令个性迥异的人一起高效地共事。',
    keywords: ['有觉察力', '关注个体', '优势导向', '精明', '公平', '准确', '有洞察力', '多元'],
  },
  {
    name: '伯乐',
    description: '善于发现并培养他人的潜能，从别人的进步中得到满足。',
    keywords: ['耐心', '鼓舞', '投入', '利他', '成长导向', '自我牺牲', '助人'],
  },
  {
    name: '积极',
    description: '热情，富有感染力，乐观向上，能感召周围的人。',
    keywords: [
      '有趣',
      '乐观',
      '满怀希望',
      '慷慨',
      '轻率',
      '快乐',
      '热情',
      '精力充沛',
      '有影响力',
      '戏剧化',
      '无忧无虑',
    ],
  },
  {
    name: '体谅',
    description: '能够设身处地体会他人的感受，能听到无声的表达，预料到别人的需要。',
    keywords: ['倾听', '容易动感情', '善表达', '敏感', '觉察', '富有直觉', '亲密', '感知力强'],
  },
  {
    name: '交往',
    description: '真诚待人，喜欢坦诚、亲密的关系，最大的满足是遇到志同道合的人。',
    keywords: ['亲切', '关心他人', '真实', '诚恳', '亲密', '透明', '坦诚', '袒露'],
  },
  {
    name: '和谐',
    description: '渴求协调一致，避免冲突，寻求共识。',
    keywords: ['实际', '现实', '回避冲突', '合作', '和气', '任务导向'],
  },
  {
    name: '分析',
    description: '以事实和数据为依据，喜欢探究事物的来龙去脉，喜欢质疑和批判。',
    keywords: ['就事论事', '数字导向', '数据驱动', '冷静', '怀疑', '质疑', '严谨'],
  },
  {
    name: '搜集',
    description: '喜欢搜集和整理，可能会积累信息、观点、标志品，甚至是关系。',
    keywords: ['有办法', '喜欢探寻', '工具意识', '慷慨', '博学', '研究'],
  },
  {
    name: '回顾',
    description: '喜欢追溯从前，通过思考过去来了解现状。',
    keywords: ['历史', '定位', '思维敏捷', '强调重点', '搜集', '好学'],
  },
  {
    name: '思维',
    description: '善于思考，勤于自省，敏于探讨。',
    keywords: ['内省', '喜独处', '理智', '哲思', '有深度', '沉思', '不容易满意', '严肃', '奋发'],
  },
  {
    name: '前瞻',
    description: '想到未来心潮澎湃，用自己对未来的憧憬激励着周围的人。',
    keywords: ['创造性', '鼓舞人心', '栩栩如生', '展望未来', '想象', '善表达', '传播', '思维敏捷', '未来导向'],
  },
  {
    name: '学习',
    description: '渴望不断丰富自我，激动的是求知的过程而非结果。',
    keywords: ['好奇', '有兴趣', '喜欢探寻', '开放', '好学', '热情', '胜任'],
  },
  {
    name: '理念',
    description: '欣赏原创精神，喜欢头脑风暴，想法或深刻、或新颖，或矛盾，或怪诞，经常被自己的想法振奋。',
    keywords: ['心血来潮', '创造性', '创新', '合作', '艺术天赋', '有洞察力', '有办法', '振奋'],
  },
  {
    name: '战略',
    description: '足智多谋，任何情形下都能迅速找出相关的规律和要点。',
    keywords: ['创造性', '头脑清晰', '容易看到可能性', '富有直觉', '未来导向', '抱有期待', '有选择的', '深思熟虑', '有洞察力'],
  },
];